module.exports = "<div class=\"act-pop-box\" style=\"display:none;\" id=\"act_msgbox_common\"><a href=\"javascript:msgExit();\" title=\"关闭\" class=\"act-pop-close act_close_box\">关闭</a><div class=\"act-pop-p-hd\"><h3 class=\"act-pop-p-titl\" name=boxTitle>温馨提示</h3></div><div class=\"act-pop-p-bd\" style=\"min-height:80px\"><p class=\"act-pop-p-sec\"><span name=\"msgbox_info\"></span></p></div><div class=\"act-pop-p-ft\"><a class=\"act-pop-btn act-pop-btn-hot\" href=\"javascript:msgExit();\" name=\"box_btn\">确定</a></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/tpl/msgbox.tpl
// module id = 13
// module chunks = 2